import React from 'react'
import PropTypes from 'prop-types'

import TableSplitButton from '~/components/TableSplitButton'
import useDeleteConfirm from '~/components/TableSplitButton/useDeleteConfirm'

function BulkActionButton ({ onBrandsDelete, loading }) {
  const { handleClick } = useDeleteConfirm()

  const options = [
    {
      label: 'Delete',
      'data-cy': 'deleteMenu',
      onMenuClick: () => handleClick(onBrandsDelete)
    },
  ]

  return (
    <TableSplitButton
      options={options}
      name="brand"
      loading={loading}
    />
  )
}

BulkActionButton.propTypes = {
  onBrandsDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default BulkActionButton
